// Verklein een foto voor snellere upload (max zijde 1600px, jpeg kwaliteit 0.75)
export async function verkleinFoto(file, maxZijde = 1600, kwaliteit = 0.75) {
  try {
    const bitmap = await createImageBitmap(file);
    const schaal = Math.min(1, maxZijde / Math.max(bitmap.width, bitmap.height));
    if (schaal === 1 && file.size < 400 * 1024) return file;
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * schaal);
    canvas.height = Math.round(bitmap.height * schaal);
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", kwaliteit));
    if (!blob || blob.size >= file.size) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}
